module.exports = __webpack_public_path__ + "img/2023big8.526f2138.png";